import { IServidor } from "@/interfaces/IServidor";
import { api } from "@/services/api";
import { servidorAction } from "@/store/actions/servidor";
import { getServidoresSynced } from "@/store/reducers/servidor";
import { useAuth } from "react-oidc-context";
import { useDispatch, useSelector } from "react-redux";

export const useServidor = () => {
  const { user } = useAuth();
  const listaServidores = useSelector(getServidoresSynced);
  const appDispatch = useDispatch();
  const { sync } = servidorAction;

  const sincronizarServidores = (servidores: IServidor[]) => {
    appDispatch(sync(servidores));
  };

  const getServidoresApi = async () => {
    const { data } = await api.get<IServidor[]>(`/servidores/todos`, {
      headers: {
        Authorization: `Bearer ${user?.access_token}`,
      },
    });
    return data;
  };

  const getServidorLogged = () => {
    return listaServidores.find(
      (servidor) => servidor.pessoa.cpfCnpj === user?.profile.cpf
    );
  };

  return {
    listaServidores,
    sincronizarServidores,
    getServidoresApi,
    getServidorLogged,
  };
};
